<script setup lang="ts">
import EmailNotificationsEditor from '~components/admin/EmailNotificationsEditor.vue'

defineProps<{
  lists: Array<{ key: string; emails: string[] }>
}>()
</script>

<template>
  <b-container fluid>
    <h1>Email Notification Settings</h1>
    <hr>
    <EmailNotificationsEditor :initial-lists="lists" />
  </b-container>
</template>
